import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { ACCOUNT_TYPE_NORMAL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import LoginFormBase from "@components/Form/LoginFormBase";
import "./style.scss";

const LoginComponent = () => {
    const location = useLocation();
    const { user, loginCheckout, isLoggedIn } = useContext(AuthContext);

    if (isLoggedIn && user.account_type_id === ACCOUNT_TYPE_NORMAL) {
        window.location = location?.state?.from ?? "/";
    }

    return (
        <LoginFormBase
            onSubmit={loginCheckout}
            showForgotPasswordLink
            disabled={false}
            displayEmail={false}
        />
    );
};

export default LoginComponent;
